import type { ReactNode } from "react";

interface FilterBarProps {
  regions: string[];
  years: string[];
  genres: string[];
  region: string;
  year: string;
  genre: string;
  sort: string;
  sorts: { key: string; label: string }[];
  onSelect: (key: "region" | "year" | "genre" | "sort", value: string) => void;
  onReset: () => void;
  className?: string;
}

function Chip({
  active,
  onClick,
  children,
}: {
  active: boolean;
  onClick: () => void;
  children: ReactNode;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`whitespace-nowrap rounded-md px-3 py-1.5 text-sm transition-colors ${
        active
          ? "bg-primary-500 text-background-50"
          : "bg-background-100 text-foreground-700 hover:bg-accent-50 hover:text-accent-600"
      }`}
    >
      {children}
    </button>
  );
}

function FilterRow({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) {
  return (
    <div className="flex flex-col gap-2 border-b border-background-200 py-4 last:border-b-0 sm:flex-row sm:items-start">
      <span className="w-16 shrink-0 pt-1 text-sm text-secondary-500">
        {label}
      </span>
      <div className="flex flex-wrap gap-2">{children}</div>
    </div>
  );
}

export default function FilterBar({
  regions,
  years,
  genres,
  region,
  year,
  genre,
  sort,
  sorts,
  onSelect,
  onReset,
  className = "",
}: FilterBarProps) {
  return (
    <div className={`rounded-lg border border-background-200 bg-background-50 p-4 md:p-5 ${className}`}>
      <FilterRow label="地区">
        {regions.map((item) => (
          <Chip
            key={item}
            active={region === item}
            onClick={() => onSelect("region", item)}
          >
            {item}
          </Chip>
        ))}
      </FilterRow>
      <FilterRow label="年份">
        {years.map((item) => (
          <Chip
            key={item}
            active={year === item}
            onClick={() => onSelect("year", item)}
          >
            {item}
          </Chip>
        ))}
      </FilterRow>
      <FilterRow label="题材">
        {genres.map((item) => (
          <Chip
            key={item}
            active={genre === item}
            onClick={() => onSelect("genre", item)}
          >
            {item}
          </Chip>
        ))}
      </FilterRow>
      <FilterRow label="排序">
        {sorts.map((item) => (
          <Chip
            key={item.key}
            active={sort === item.key}
            onClick={() => onSelect("sort", item.key)}
          >
            {item.label}
          </Chip>
        ))}
        <button
          type="button"
          onClick={onReset}
          className="flex items-center gap-1 whitespace-nowrap rounded-md border border-background-300 px-3 py-1.5 text-sm text-secondary-600 transition-colors hover:border-accent-400 hover:text-accent-600"
        >
          <i className="ri-refresh-line"></i>
          重置筛选
        </button>
      </FilterRow>
    </div>
  );
}